export default (collection = {}) => ({
  collection,
  impressions: [],
  impressionsBatchLimit: 8,
  productElements: [],

  init() {
    const productCardSelector = ".card-product, .card-outfit";
    this.productElements = this.$el.querySelectorAll(productCardSelector);
    this.initTracking();
    this.$watch("impressions", this.impressionsTracking.bind(this));
  },

  impressionsTracking() {
    let allProductsViewed = true;
    this.productElements.forEach((productCard) => {
      if (!productCard.hasAttribute("data-viewed")) {
        allProductsViewed = false;
      }
    });

    const impressionsAmount = this.impressions.length;

    if (
      impressionsAmount === this.impressionsBatchLimit ||
      (allProductsViewed && impressionsAmount > 0)
    ) {
      // stringify and parse to get rid of Alpines Proxy(Object)
      Tracking.viewItemList(JSON.parse(JSON.stringify(this.impressions)));
      this.impressions = [];
    }
  },

  getProductTrackingData(productElement) {
    const { handle: collectionHandle, title: collectionTitle } =
      this.collection;
    const { id, title, price, vendor, type, index } = productElement.dataset;

    try {
      const data = {
        item_id: id,
        item_name: title,
        price: parseFloat(price) / 100,
        item_brand: vendor,
        item_category: type,
      };

      if (collectionHandle) {
        data["item_list_id"] = collectionHandle;
      }

      if (collectionTitle) {
        data["item_list_name"] = collectionTitle;
      }

      if (index) {
        data["index"] = parseInt(index);
      }

      return data;
    } catch (error) {
      console.log(error);
    }

    return;
  },

  markAsViewed(element) {
    element.dataset.viewed = "true";
  },

  initTracking() {
    const instantTrackingLimit = 4;
    const instantTrackingProducts = [];
    for (
      let productIndex = 0;
      productIndex < this.productElements.length;
      ++productIndex
    ) {
      if (productIndex < instantTrackingLimit) {
        const productCard = this.productElements[productIndex];
        const trackingData = this.getProductTrackingData(productCard);
        this.markAsViewed(productCard);
        instantTrackingProducts.push(trackingData);
      } else {
        this.setupTrackingObserver(productIndex);
      }
    }

    Tracking.viewItemList(instantTrackingProducts);
  },

  setupTrackingObserver(productIndex) {
    // Track productcards in view
    const productCard = this.productElements[productIndex];

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const intersecting =
          entry.intersectionRatio > 0 || entry.isIntersecting;
        if (intersecting) {
          this.impressions.push(this.getProductTrackingData(productCard));
          this.markAsViewed(productCard);
          observer.unobserve(entry.target);
        }
      });
    });
    observer.observe(productCard);
  },
});
